import { runInAction } from 'mobx';
import { orderDomainStore } from '../../store';
export const clearOrderSubscriptionSelection = () => {
    runInAction(() => {
        orderDomainStore.data.selections.subscription = undefined;
    });
};
